import 'jquery'
import $ from 'jquery';
window.$ = window.jQuery = $;
import 'slick-carousel'
import './script.js';
// import mCustomScrollbar from 'mCustomScrollbar';

const fancybox = require("@fancyapps/fancybox");


